import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useDialog } from "../../data/providers/DialogProvider";

export function AppDialog() {
  const {
    open,
    title,
    content,
    confirmText,
    cancelText,
    loading,
    onConfirm,
    closeDialog,
  } = useDialog()!;

  return (
    <Dialog open={open} onClose={closeDialog}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} disabled={loading}>
          {cancelText}
        </Button>
        <Button onClick={onConfirm} color="error" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
